import Vue from 'vue';
import VueRouter from 'vue-router';
import Landing from '../views/Landing.vue';
import FreeClient from '../views/FreeClient.vue';
import Kiosk from '../views/Kiosk.vue';
import Outgoing from '../views/Outgoing.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'landing',
    component: Landing
  },
  {
    path: '/desktop',
    name: 'desktop',
    component: Landing
  },
  {
    path: '/freeclient/:room?',
    name: 'freeclient',
    component: FreeClient,
    props: true
  },
  {
    path: '/kiosk/:room?',
    name: 'kiosk',
    component: Kiosk,
    props: true
  },
  {
    path: '/calling',
    name: 'Outgoing',
    component: Outgoing
  }
];

export default function createRouter (base) {
  const router = new VueRouter({
    mode: 'history',
    base: base,
    routes
  });

  router.beforeEach((to, from, next) => {
    if (to.name === 'desktop') {
      to.params.desktop = 'desktop';
    }
    next();
  });
  return router;
};
